firebird.directive('routeResetter', [
    'cookieService',
    'routerService',
    function (cookieService, routerService) {
        return {
            restrict: 'A',
            scope: {
                isHost: '@isHost'
            },
            link: function (scope, element) {
                //Decided to keep this logic in the directive (as opposed to in a controller).
                //Reason being this can be reused in multiple places if needed.
                //
                //Also, I didn't think this type of logic was relevant to the loadingPopupCtrl,
                //which is currently the only place it gets called

                element.on('click', function () {
                    if (scope.isHost === 'true') {
                        //Go to account manager
                        routerService.goToAccountManager();
                    } else {
                        //update cache and go to loginpage
                        var userCache = cookieService.getObject('userCache');

                        if (userCache) {
                            userCache.autologin = false;

                            var tomorrow = new Date();
                            tomorrow.setDate(tomorrow.getDate() + 1);
                            cookieService.putObject('userCache', userCache, {
                                expires: tomorrow,
                                secure: true,
                                samesite: 'strict'
                            });
                        }

                        routerService.refreshPage();
                    }
                });
            }
        };
    }
]);
